import React from "react";
import { useTranslation } from "react-i18next";

import "./styles.less";

export const TimeLineBanner = () => {
  const { t } = useTranslation();
  return (
    <div className="timeline-banner">
      <div className="timeline-banner-title">{t("common.timeline-title")}</div>
      <div className="timeline-banner-subtitle">
        {t("common.timeline-slogan")}
      </div>
    </div>
  );
};
